import React from "react";
// import ReactDOM from "react-dom";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { t } from 'react-multi-lang';

import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';

import enMessages from './../custom_modules/translations/en/en.json';
import koMessages from './../custom_modules/translations/ko/ko.json';
import frMessages from './../custom_modules/translations/fr/fr.json';
import grMessages from './../custom_modules/translations/de/de.json';
loadMessages(enMessages, "en-En");
loadMessages(koMessages, "ko-KO");
loadMessages(frMessages, "fr-FR");
loadMessages(grMessages, "de-DE");

class KendoCombobox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.Datasource,
      DefaultValue: this.props.DefaultValue,
      disabled: this.props.disabled,
      loading: false
    };
    this.comboBoxRef = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(
    nextProps,
    nextState,
    prevProps,
    prevState,
    nextContext,
    prevContext
  ) {

    if (nextProps.Datasource !== undefined) {
      this.setState({ data: nextProps.Datasource });
    }
    if (nextProps.DefaultValue === undefined) {
      this.setState({ DefaultValue: "" });
    } else {
      if (
        nextProps.DefaultValue !== null &&
        nextProps.DefaultValue[this.props.DisplayMember] !== undefined
      ) {
        nextProps.DefaultValue[
          this.props.DisplayMember
        ] = nextProps.DefaultValue[this.props.DisplayMember].toString();
      }

      this.setState({ DefaultValue: nextProps.DefaultValue });
    }

    this.setState({ disabled: nextProps.disabled });
  }

  onFocus = () => {
    if (this.comboBoxRef.current && !this.comboBoxRef.current.state.opened) {
      this.comboBoxRef.current.toggleBtnClick();
    }
  };

  onOpen(e) { }
  onClose(e) { }
  // onFocus(e) { }
  onBlur(e) { }
  onChange(e) {

    if (e.target.value !== null) {
      if (this.props.ValueMember !== undefined && this.props.DisplayMember !== undefined) {
        e.target.value[this.props.DisplayMember] = e.target.value[
          this.props.DisplayMember
        ].toString();
      }
    }
    this.setState({ DefaultValue: e.target.value });
    this.props.onvaluechange(e.target.value);
  }

  onFilterChange(event) {
    this.setState({
      data: this.filterData(event.filter),
      loading: false
    });
  }

  filterData(filter) {
    let data = [];
    if (this.props.Datasource !== undefined) {
      data = this.props.Datasource.slice();
    }
    return filterBy(data, filter);
  }

  render() {
    let lang = localStorage.getItem("ElnLang");
    let localizeprovider = "en-EN";
    if (lang !== null) {
      localizeprovider = lang + "-" + lang.toUpperCase();
    }

    if (this.props.ValueMember === undefined && this.props.DisplayMember === undefined) {
      return (
        <LocalizationProvider language={localizeprovider}>
          <ComboBox
            ref={this.comboBoxRef}
            t={this.props.t}
            id={this.props.id}
            data={this.state.data}
            onOpen={this.onOpen.bind(this)}
            onClose={this.onClose.bind(this)}
            onFocus={this.onFocus}
            onBlur={this.onBlur.bind(this)}
            onChange={this.onChange.bind(this)}
            onFilterChange={this.onFilterChange.bind(this)}
            filterable={true}
            value={this.state.DefaultValue}
            placeholder={this.props.Placeholder}
            disabled={this.state.disabled}
            className={this.props.additionalclass !== undefined ? "clsKenodCombo " + this.props.additionalclass : "clsKenodCombo"}
            popupSettings={{ className: this.props.className ? this.props.className : "clscombopop" }}
          />
        </LocalizationProvider>
      );
    }
    else {

      return (
        <LocalizationProvider language={localizeprovider}>
          <ComboBox
            ref={this.comboBoxRef}
            id={this.props.id}
            t={this.props.t}
            data={this.state.data}
            onOpen={this.onOpen.bind(this)}
            onClose={this.onClose.bind(this)}
            onFocus={this.onFocus}
            onBlur={this.onBlur.bind(this)}
            onChange={this.onChange.bind(this)}
            onFilterChange={this.onFilterChange.bind(this)}
            filterable={true}
            dataItemKey={this.props.ValueMember}
            value={this.state.DefaultValue}
            textField={this.props.DisplayMember}
            placeholder={this.props.Placeholder}
            disabled={this.state.disabled}
            className={this.props.additionalclass !== undefined ? "clsKenodCombo " + this.props.additionalclass : "clsKenodCombo"}
            popupSettings={{ className: this.props.className ? this.props.className : "clscombopop" }}
          />
        </LocalizationProvider>
      );

    }
  }
}
export default KendoCombobox;
